import * as types from '../mutation-types/profile'
// set this true to namespace all getters, mutations, actions etc.
const namespaced = true
export const namespace = 'profile'

// state
const state = {
  selectedTab: null,
  selectedSubTab: null,
  playcards: null,
  playcard: null,
  giftcards: null,
  giftcard: null,
  memberships: null,
  isLoadingGiftCards: false,
  isLoadingPlayCards: false,
  isLoadingMemberships: false,
}

// mutations
const mutations = {
  [types.SET_GIFTCARD](state, item) {
    state.giftcard = item
  },
  [types.SET_GIFTCARDS](state, items) {
    state.giftcards = items
  },
  [types.SET_MEMBERSHIPS](state, items) {
    state.memberships = items
  },
  [types.SET_PLAYCARD](state, item) {
    state.playcard = item
  },
  [types.SET_PLAYCARDS](state, items) {
    state.playcard = items
  },
  [types.SET_PRIMARY_TAB](state, item) {
    state.selectedTab = item
  },
  [types.SET_SECONDARY_TAB](state, item) {
    state.selectedSubTab = item
  },
  [types.SET_LOADING_MEMBERSHIPS](state, item) {
    state.isLoadingMemberships = !!item
  },
  [types.SET_LOADING_GIFTCARDS](state, item) {
    state.isLoadingGiftCards = !!item
  },
  [types.SET_LOADING_PLAYCARDS](state, item) {
    state.isLoadingPlayCards = !!item
  },
}

//actions
const actions = {
  setProfilePrimaryTab({commit}, payload) {
    commit(types.SET_PRIMARY_TAB, payload)
  },
  setProfileSecondaryTab({commit}, payload) {
    commit(types.SET_SECONDARY_TAB, payload)
  },
  setLoadedMemberships({commit}, payload) {
    commit(types.SET_MEMBERSHIPS, payload)
  },
  updateGiftCard({commit, state}, card) {
    if (!state.giftcards) {
      state.giftcards = []
    }
    const cards = state.giftcards
    let found = _.findIndex(cards, i => i.id === card.id)
    if (found < 0) {
     found =  cards.length
    }
    Vue.set(state.giftcards, found, card)
  },
  setLoadedGiftCards({commit}, payload) {
    commit(types.SET_GIFTCARDS, payload)
  },
  setLoadedGiftCard({commit}, payload) {
    commit(types.SET_GIFTCARD, payload)
  },
  setLoadedPlayCards({commit}, payload) {
    commit(types.SET_PLAYCARDS, payload)
  },
  setLoadedPlayCard({commit}, payload) {
    commit(types.SET_PLAYCARD, payload)
  },
  initMembershipsLoading({commit}) {
    commit(types.SET_LOADING_MEMBERSHIPS, true)
  },
  endMembershipsLoading({commit}) {
    commit(types.SET_LOADING_MEMBERSHIPS, false)
  },
  initGiftCardsLoading({commit}) {
    commit(types.SET_LOADING_GIFTCARDS, true)
  },
  endGiftCardsLoading({commit}) {
    commit(types.SET_LOADING_GIFTCARDS, false)
  },
  initPlayCardsLoading({commit}) {
    commit(types.SET_LOADING_PLAYCARDS, true)
  },
  endPlayCardsLoading({commit}) {
    commit(types.SET_LOADING_PLAYCARDS, false)
  },
}

// getters
const getters = {
  loadedGiftCards: state => state.giftcards,
  loadedGiftCard: state => state.giftcard,
  loadedPlayCards: state => state.playcards,
  loadedPlayCard: state => state.playcard,
  loadedMemberships: state => state.memberships,
  selectedPrimaryTab: state => state.selectedTab,
  selectedSecondaryTab: state => state.selectedSubTab,
  isLoadingMemberships: state => state.isLoadingMemberships,
  isLoadingGiftCards: state => state.isLoadingGiftCards,
  isLoadingPlayCards: state => state.isLoadingPlayCards,

}

// plugins
const plugins = []

const giftcard = {namespaced, namespace, state, mutations, actions, getters, plugins}
export default giftcard
